const resumeData = {
  personalDetails: {
    name: "Siddharth Chopra",
    title: "Software Developer",
    email: "sidchopp@gmail.com",
    linkedin: "https://www.linkedin.com/in/sidchopp",
    phone: "(587) 436-7497",
    location: "Calgary- AB",
  },
  summary:
    "Innovative, task-driven Full Stack Software Developer with expertise in both Frontend and Backend development, proven ability to adapt in both self-starting and collaborative environments. Adept in navigating fast-paced dynamic work environments, excel in delivering innovative solutions that align with evolving business requirements.",
  sections: [
    {
      title: "PROFESSIONAL SUMMARY",
      items: [
        "Proficient in building web applications using modern web frameworks, prioritizing clean, efficient and reusable code for both Client and Server sides",
        "Strong emphasis on fostering excellent UI/UX and following software development best practices, utilizing CI/CD for streamlined processes",
        "Effective collaboration with cross-functional teams, stakeholders, designers, content teams, and product owners to manage multiple projects with parallel deadlines",
        "Analytical problem-solving skills, ensuring swift issue resolution, and maintaining professional communication with management, internal teams and clients",
        "Passionate for knowledge sharing within the team, and genuine excitement for continuous learning of new technologies",
      ],
    },
    {
      title: "PROFESSIONAL EXPERIENCE",
      items: [
        {
          role: "Senior Full Stack Web Developer",
          company: "Fresh Tracks Canada",
          location: "Vancouver, BC",
          period: "08/2025 – Present",
          responsibilities: [
            "Architect and build performant web applications using React/Next.js and Node.js on Google Cloud Run",
            "Design and advise on backend APIs, database models (BigQuery/SQL), and CMS schemas (DatoCMS)",
            "Collaborate with designers, marketers, and other teams to continuously improve the web experience and SEO performance",
            "Review and evolve our CI/CD pipelines (GitHub Actions, Cloud Build), development practices, and testing workflows",
            "Maintain accessibility and performance standards across multiple sites",
          ],
        },
        {
          role: "Full Stack Software Developer",
          company: "Eau Claire Partners",
          location: "Calgary, AB",
          period: "10/2024 – 07/2025",
          responsibilities: [
            "Design and implement scalable backend services and APIs using TypeScript, Strapi, Python, and PostgreSQL, with a focus on performance, security, and data integrity",
            "Develop and maintain responsive front-end applications using React, Next.js, delivering intuitive user experiences across devices",
            "Deploy and manage cloud-native infrastructure on AWS, ensuring high availability, scalability, and cost optimization",
            "Integrate third-party systems and APIs, enabling seamless data flow and interoperability across platforms",
            "Collaborate with cross-functional teams to deliver end-to-end solutions and authored clear, developer-friendly API documentation for internal and external stakeholders",
          ],
        },
        {
          role: "Software Developer",
          company: "Free Lancer",
          location: "Calgary, AB",
          period: "05/2024 – 09/2024",
          responsibilities: [
            "Worked on independent projects that encompass both Front-end and Back-end development, meticulously adhering to Test-Driven Development practices and other industry-leading standards and provided robust, scalable, and high-quality software solutions to multiple clients.",
          ],
        },
        {
          role: "Software Developer",
          company: "Neo Financial",
          location: "Calgary, AB",
          period: "08/2022 – 04/2024",
          responsibilities: [
            "Crafting web-based interfaces and architecting reusable components utilizing Next.js, TypeScript, GraphQL, AWS for microservices, and Vercel for streamlined deployments",
            "Collaborating seamlessly with fellow developers to engineer lasting solutions that surpass contemporary benchmarks for efficiency, scalability, accessibility, and security",
            "Consistently delivering high-quality code, actively engaging in peer code reviews and design assessments, and demonstrating a commitment to robust unit testing",
            "Mentoring junior peers to enhance their skill sets and actively contributing to the team’s collective knowledge base",
          ],
        },
        {
          role: "Full Stack Developer",
          company: "Free Lancer",
          location: "Calgary, AB",
          period: "02/2021 – 07/2022",
          responsibilities: [
            "Successfully developed and deployed 20+ commercially viable, feature-rich, and robust web products from initial prototype to final product",
            "Led comprehensive efforts covering visual design, solid code implementation with efficient unit tests, browser testing, ongoing maintenance, and prioritize an exceptional User experience",
          ],
        },
        {
          role: "Full Stack Developer",
          company: "InceptionU Ltd.",
          location: "Calgary, AB",
          period: "09/2020 – 02/2021",
          responsibilities: [
            "Successfully designed and deployed a MERN stack app for a client, employing agile development practices. The app streamlined the search process for tech events in Alberta, resulting in 25% reduction in user search time",
            "Proficient in server scripts and RESTful APIs, with a focus on comprehensive testing using POSTMAN",
          ],
        },
        {
          role: "MCAT Physics Instructor (Part -time)",
          company: "The Princeton Review",
          location: "Calgary, AB",
          period: "03/2020 – 02/2022",
          responsibilities: [
            "Instructed Physics to pre-medical students preparing for MCAT",
            "Provided guidance, mentorship, and assistance to students while upholding high standards of professionalism and delivered high-quality results",
          ],
        },
        {
          role: "Web Developer",
          company: "Adlib Advertising & Marketing Consultants",
          location: "Chandigarh, India",
          period: "01/2019 – 09/2020",
          responsibilities: [
            "Collaborated with a team of Web developers and Digital Strategists, providing support to numerous early-stage ventures",
            "Transformed clients’ legacy web assets from vanilla JavaScript to React.js, resulting in around 30% increase in user base",
            "Refactored old code following best practices, reducing instances of bugs and down time by 20%",
          ],
        },
      ],
    },
    {
      title: "EDUCATION",
      items: [
        "Full Stack Development Program, InceptionU, Calgary, AB, Canada",
        "Software Product Management Specialization, University of Alberta, AB, Canada",
        "Master’s Degree in Physics (with Mathematics), Panjab University, Chandigarh, India",
      ],
    },
    {
      title: "CLOUD CERTIFICATIONS",
      items: [
        {
          name: "AWS Certified Developer - Associate",
          url: "https://www.credly.com/badges/73443cb2-75ab-4fce-97b6-771d7be5912a?source=linked_in_profile",
        },
        {
          name: "AWS Certified Cloud Practitioner",
          url: "https://www.credly.com/badges/86e0a91c-4f81-4915-b135-3a527e56e9da/public_url",
        },
      ],
    },
    {
      title: "TECHNICAL SKILLS",
      items: [
        "Client-side: React.js, Next.js, JavaScript, TypeScript, HTML, CSS, JEST Testing, MUI, tailwind CSS",
        "Server-side: Node.js, AWS, Express, REST APIs, GraphQL, MongoDB, PostgreSQL, Contentful CMS",
        "Development: Scrum, Agile, Git, GitHub, Visual Studio Code",
        "Deployment: CICD, Vercel, Heroku, AWS, Netlify",
      ],
    },
    {
      title: "SOFT SKILLS",
      items: [
        "Communication Skills",
        "Problem solving",
        "Strong Work Ethics",
        "Attention to details",
        "Team player",
        "Positive attitude",
        "Leadership skills",
        "Creative",
      ],
    },
    {
      title: "VOLUNTEER WORK",
      items: [
        "Center for Newcomers, Calgary-AB, Canada (https://www.centrefornewcomers.ca/): A Volunteer for Centre for Newcomers for “The Legacy Campaign – Get in touch with the Community” which is a living snapshot of Calgary’s Cultural Legacy",
      ],
    },
  ],
};

export { resumeData };
